import { render } from "./EllipseTwo.svg?vue&type=template&id=bd4fe6ec"
const script = {}
script.render = render

export default script